import { useNavigate } from "react-router-dom";
/**
 * @file Lists pages currently in review (pending approvals) with filters.
 */
import { useEffect, useMemo } from "react";
import { PagesDirectory } from "@/components/pages/PagesDirectory";
import { useAuth } from "@/lib/auth-context";
import { canReviewApprovals } from "@/lib/permissions";
import { Box, Typography } from "@mui/material";

export function ApprovalsPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const allowed = useMemo(() => canReviewApprovals(user?.roles), [user?.roles]);

  useEffect(() => {
    if (user && !allowed) {
      navigate("/dashboard", { replace: true });
    }
  }, [user, allowed, navigate]);

  if (user && !allowed) {
    return (
      <Typography variant="body2" color="text.secondary">
        Redirecting…
      </Typography>
    );
  }

  return (
    <Box>
      <PagesDirectory
        title="Pending approvals"
        description="Pages awaiting review (including live pages with changes in review)."
        reviewQueueOnly
      />
    </Box>
  );
}
